import { render } from "./Anmerkungen.vue?vue&type=template&id=4970f751&scoped=true&ts=true"
import script from "./Anmerkungen.vue?vue&type=script&lang=ts"
export * from "./Anmerkungen.vue?vue&type=script&lang=ts"

import "./Anmerkungen.vue?vue&type=style&index=0&id=4970f751&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4970f751"]])

export default __exports__